module.exports = __webpack_public_path__ + "img/img4.64cfa320.jpg";